<template>
  <div>
    <page-title title="Users" />
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ApplicationUserList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'applicationUsers',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'email',
            name: 'Email Address',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'userName',
            name: 'User Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'firstName',
            name: 'First Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'lastName',
            name: 'Last Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'organization',
            name: 'Organization',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'city',
            name: 'City',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'state',
            name: 'State',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'postalCode',
            name: 'Postal Code',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'country',
            name: 'Country',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'isCertified',
            name: 'Certified',
            visible: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'true', text: 'Certified' },
              { value: 'false', text: 'Not Certified' }
            ],
            render: function (v) {
              return v ? 'Certified' : 'Not Certified';
            }
          },
          {
            key: 'sendMarketingEmails',
            name: 'Marketing Emails',
            visible: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'true', text: 'Yes' },
              { value: 'false', text: 'No' }
            ],
            render: function (v) {
              return v ? 'Yes' : 'No';
            }
          }
        ],
        getDefaultFilter: function () {
          return '';
        },
        rowClicked: function (item, context) {
          context.$router.push('/applicationUser/' + item.id);
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>